import { AsteriskIcon, CalendarDotsIcon, TelegramLogoIcon, UsersIcon } from '@phosphor-icons/react'
import { TFunction } from 'i18next'

import { getChannelLabel } from '@/pages/communication/surveys/surveys.constants'

import { type SurveyDetailsPanelData, type SurveyField } from './survey-details-panel.types'

export const getSurveyDetailsPanelFields = (
  data: SurveyDetailsPanelData,
  t: TFunction<['communication']>,
): SurveyField[] => {
  return [
    {
      icon: TelegramLogoIcon,
      label: t('communication:surveyDetails.panel.fields.communicationType'),
      value: getChannelLabel(data.communicationType, t),
    },
    {
      icon: AsteriskIcon,
      label: t('communication:surveyDetails.panel.fields.surveyType'),
      value: data.surveySubtype ? `${data.surveyType} (${data.surveySubtype})` : data.surveyType,
    },
    {
      icon: UsersIcon,
      label: t('communication:surveyDetails.panel.fields.recipients'),
      value: data.recipients,
    },
    {
      icon: CalendarDotsIcon,
      label: t('communication:surveyDetails.panel.fields.startEndDate'),
      value: data.startAndEndDates,
    },
  ]
}
